// GA4 + Meta Pixel tracking — REPLACE THE TWO PLACEHOLDER IDS BELOW.
// GA_ID  example: "G-AB12CD34EF"   (Google Analytics 4 Measurement ID)
// PIXEL_ID example: "1234567890123456" (Meta Pixel ID)
export const GA_ID = "G-XXXXXXXXXX";
export const PIXEL_ID = "719294380555928";

const gaReady = () => GA_ID && !GA_ID.startsWith("G-XXXX");
const pxReady = () => PIXEL_ID && PIXEL_ID !== "000000000000000";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "fbclid", "gclid"];

export function captureUTM() {
  try {
    const params = new URLSearchParams(window.location.search);
    let stored = {};
    try {
      stored = JSON.parse(sessionStorage.getItem("ahq_utm") || "{}");
    } catch (e) {
      stored = {};
    }
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) stored[k] = v;
    });
    // referring domain (for Eagle CRM lead attribution)
    if (document.referrer && !stored.referrer) {
      stored["referrer"] = document.referrer.slice(0, 200);
      try {
        stored["referrer_domain"] = new URL(document.referrer).hostname.slice(0, 120);
      } catch (e) {
        stored["referrer_domain"] = "unknown";
      }
    }
    if (Object.keys(stored).length) sessionStorage.setItem("ahq_utm", JSON.stringify(stored));
    return stored;
  } catch (e) {
    return {};
  }
}

export function initTracking() {
  captureUTM();
  if (gaReady()) {
    if (!document.getElementById("ga4-script")) {
      const s = document.createElement("script");
      s.id = "ga4-script";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", GA_ID, { send_page_view: true });
    }
  }
  if (pxReady()) {
    if (!window.fbq) {
      const n = (window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      });
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(s);
      window.fbq("init", PIXEL_ID);
      window.fbq("track", "PageView");
    }
  }
}

// Central event fire: GA4 event + Meta custom event + console.debug until IDs are set.
export function trackEvent(name, props = {}) {
  try {
    if (gaReady() && window.gtag) window.gtag("event", name, props);
    if (pxReady() && window.fbq) window.fbq("trackCustom", name, props);
    // eslint-disable-next-line no-console
    console.debug("[track]", name, props);
  } catch (e) {
    /* tracking must never break the page */
  }
}
